import type { Subscription } from '../../models/Subscription.d.ts';
import type { SupabaseClient } from '@supabase/supabase-js';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, price_id, user_id, subscription_id, cancel_at_period_end, current_period_end`;

export class SubscriptionRepository extends SupabaseRepository<Subscription> {
  constructor(client: SupabaseClient) {
    super('subscriptions', selector, client);
  }
}
